import NotFound from './components/NotFound'
export default () => ({
  path: '*',
  element: <NotFound />,
})
